import { render, staticRenderFns } from "./SpecialEventCard.vue?vue&type=template&id=183ab21d&scoped=true&"
import script from "./SpecialEventCard.vue?vue&type=script&lang=js&"
export * from "./SpecialEventCard.vue?vue&type=script&lang=js&"
import style0 from "./SpecialEventCard.vue?vue&type=style&index=0&id=183ab21d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183ab21d",
  null
  
)

export default component.exports